import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LayoutsModule } from './layouts/layouts.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { ToastComponent } from './shared/components/toast/toast.component';
import { StatusPageComponent } from './shared/components/status-page/status-page.component';
import { EnvironmentInterceptor } from './core/helpers/environment.interceptor';
import { EsignApiKeyInterceptor } from './core/helpers/esign-api-key.interceptor';
import { EstampApiKeyInterceptor } from './core/helpers/estamp-api-key.interceptor';
import { UiModule } from './shared/ui/ui.module';
import { PagesModule } from './pages/pages.module';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent,
    StatusPageComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    PagesModule,
    LayoutsModule,
    FormsModule,
    UiModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: EsignApiKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EstampApiKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EnvironmentInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
